import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartRoutingModule } from './chart-routing.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ServiceChartComponent } from './service-chart/service-chart.component';

@NgModule({
  declarations: [
    ServiceChartComponent
  ],
  imports: [
    CommonModule,
    ChartRoutingModule,
    NgxSpinnerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChartModule { }
